/**
 * @Author: zhengpengcheng
 * @Description:
 * @DateTime: Created in 2022-11-09 14:28:00
 */

 import Api from '../../../../util/api';
 import {PageDo, Result, ResultPageDo } from '../../../../types/base';
 import { defaultNullValue } from 'src/config';
 
 export declare namespace OperatingKeyDOI {
    export interface RowDataI {
        id: number;
        datetime: string;
        operator: string;
        error_no: string;
        error_info: string;
        content:  string;
    }
 
    export interface QueryRowDataParamsI extends PageDo {
        error_info: string;
        end_time?   : number;
        start_time? : number;
    }
 }


 export default class OperatingKeyApi {
    /**
     * 获取报错信息列表
     */
    static async searchList(params: OperatingKeyDOI.QueryRowDataParamsI): Promise<ResultPageDo<OperatingKeyDOI.RowDataI[]>> {
        return Api.post('/ops/error_info_log/list/get', {
            ...params,
        });
    }
 }
 